import React from 'react';
import { Link } from 'react-router';
import General from '../modules/General';

//this.props.router.push(General.Link('/settings/billing/plan'))
const UpgradeRequired = (props) => (
    <div className="alert alert-icon alert-warning alert-dismissible" role="alert">
        <i className="icon wb-bell" aria-hidden="true"></i>  {props.message}
        <p className="m-t-15">
            <Link to={General.Link(`/settings/billing/plan`)} className="btn btn-warning">Upgrade</Link>
        </p>
    </div>
);

export default UpgradeRequired;



// WEBPACK FOOTER //
// ./components/UpgradeRequired.js